import React from 'react'
import SupportHeader from '../components/SupportHeader';
import SupportFooter from '../components/SupportFooter';

const ProtectedSupportLayout = ({ children }) => {
    return (
      <div
        style={{ overflow: "hidden" }}
        onContextMenu={(e) => e.preventDefault()}
      >
        <SupportHeader title={"My Support Ticket"} />
        {children}
        <SupportFooter />
      </div>
    );
};

export default ProtectedSupportLayout;
